exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".request-certificate{padding:20px;overflow:auto;max-height:calc(100vh - 91px)}.request-certificate .instructions p{line-height:1.4;font-size:.85rem}.request-certificate .controls{margin-top:15px;display:flex;justify-content:center;margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Certificates/RequestCertificate.scss
// module id = 836
// module chunks = 0